import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cellular-billing-review-dialog',
  styleUrls: ['../billing-dialog.scss'],
  template: `
    <h2 mat-dialog-title>Report exported</h2>
    <mat-dialog-content>
      <div class="success-icon" aria-hidden="true"><mat-icon>check</mat-icon></div>
      <p>
        Version {{ data.version }} was saved and downloaded. Would you like to email
        <strong>{{ data.recipient }}</strong> a secure portal link for review?
      </p>
      <p class="review-note">The link opens the saved report for approval or revision comments after sign in.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close(false)">Not now</button>
      <button mat-raised-button color="primary" type="button" (click)="dialogRef.close(true)">
        <mat-icon>mail_outline</mat-icon>
        Email for review
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content { text-align: center; }
    .success-icon { display: inline-flex; align-items: center; justify-content: center; width: 52px; height: 52px; margin: 4px 0 12px; border-radius: 50%; background: #e9f7ef; color: #087a46; }
    .review-note { color: #687580; font-size: 12px; }
    button mat-icon { margin-right: 6px; }
  `]
})
export class CellularBillingReviewDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CellularBillingReviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { version: number, recipient: string }
  ) { }
}
